export default {
  'component.globalHeader.search': '検索',
  'component.globalHeader.search.example1': '検索例 1',
  'component.globalHeader.search.example2': '検索例 2',
  'component.globalHeader.search.example3': '検索例 3',
  'component.globalHeader.help': 'ヘルプ',
  'component.globalHeader.notification': '通知',
  'component.globalHeader.notification.empty':
    'すべての通知を確認しました。',
  'component.globalHeader.message': 'メッセージ',
  'component.globalHeader.message.empty': 'すべてのメッセージを確認しました。',
  'component.globalHeader.event': 'イベント',
  'component.globalHeader.event.empty': 'すべてのイベントを確認しました。',
  'component.noticeIcon.clear': 'クリア',
  'component.noticeIcon.cleared': 'クリアされました',
  'component.noticeIcon.empty': '通知はありません',
  'component.noticeIcon.view-more': 'もっと見る',
};
